export const environment = {
  production: false,
  debug: true,
  displayInfo: 'Develop',
  baseUrl: 'https://dev-api.timeswift.one/'
};
